import { ActionGroup } from "@mittwald/flow-remote-react-components";
import { Button } from "@mittwald/flow-remote-react-components";
import { typedList } from "@mittwald/flow-remote-react-components";
import { ModalTrigger } from "@mittwald/flow-remote-react-components";
import { useListDirectoryProtections } from "../../hooks/useListDirectoryProtections";
import { NoDirectoryProtections } from "./NoDirectoryProtections";
import {
  DirectoryProtectionListItem,
  DirectoryProtectionListProps,
} from "./DirectoryProtectionListItem";
import { CreateDirectoryProtectionModal } from "./CreateDirectoryProtectionModal";

export const DirectoryProtectionList = (props: { projectId: string }) => {
  const DirectoryProtectionList = typedList<DirectoryProtectionListProps>();

  const directoryProtections = useListDirectoryProtections(props.projectId);
  const directoryProtectionsListData = directoryProtections.data.map(
    (directoryProtection) => ({
      description: directoryProtection.description,
      users: directoryProtection.users,
      path: directoryProtection.path,
      appInstallationId: directoryProtection.appInstallationId,
    }),
  );

  if (directoryProtections.data.length == 0) {
    return <NoDirectoryProtections projectId={props.projectId} />;
  }

  return (
    <>
      <DirectoryProtectionList.List>
        <DirectoryProtectionList.StaticData
          data={directoryProtectionsListData}
        />
        <DirectoryProtectionList.Sorting
          property="description"
          name="Name A bis Z"
          direction="asc"
          defaultEnabled
        />
        <DirectoryProtectionList.Sorting
          property="description"
          name="Name Z bis A"
          direction="desc"
        />
        <ActionGroup>
          <ModalTrigger>
            <Button color="success">Passwortschutz anlegen</Button>
            <CreateDirectoryProtectionModal projectId={props.projectId} />
          </ModalTrigger>
        </ActionGroup>

        <DirectoryProtectionList.Search />
        <DirectoryProtectionList.Item>
          {(directoryProtection) => (
            <DirectoryProtectionListItem
              directoryProtection={directoryProtection}
              projectId={props.projectId}
            />
          )}
        </DirectoryProtectionList.Item>
      </DirectoryProtectionList.List>
    </>
  );
};
